import { getAccountCanAccessBeta } from 'redux/selectors/accounts';
import { createSelector } from 'reselect';
import { getRecommendedMemoryTracker, getTicCompatibleMemoryTracker } from 'utils/memoryTracker';

/**
 * Input selector that reads navigator.userAgent so reselect re-evaluates
 * OS-dependent selectors when the user agent changes (e.g. in tests).
 */
const getUserAgent = () => window.navigator.userAgent;

/**
 * The Memory tracker recommended for the current OS, respecting the account's beta access.
 * Prerelease trackers (Memory for Linux) are only offered to beta-enabled accounts.
 */
export const getRecommendedMemoryTrackerForAccount = createSelector(
  [getAccountCanAccessBeta, getUserAgent],
  canAccessBeta => getRecommendedMemoryTracker({ allowPrereleaseTrackers: canAccessBeta })
);

export const getHasRecommendedMemoryTracker = createSelector(
  [getRecommendedMemoryTrackerForAccount],
  tracker => !!tracker
);

/**
 * Like {@link getRecommendedMemoryTrackerForAccount} but limited to TIC-compatible trackers
 * (no Chrome extension). Also gates Memory for Linux behind beta access.
 */
export const getTicCompatibleMemoryTrackerForAccount = createSelector(
  [getAccountCanAccessBeta, getUserAgent],
  canAccessBeta => getTicCompatibleMemoryTracker({ allowPrereleaseTrackers: canAccessBeta })
);
